import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import SetHeader from "../../../_components/_common/Header/SetHeader";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import N_tick from "../../../../src/assets/images/N_tick.png";
import N_wws_warehousing from "../../../assets/images/warehousing_icon.png";
import N_wws_fumigation from "../../../assets/images/fumignation_icon.png";
import test_icon from "../../../assets/images/test_icon.png";
import N_wws_Stockpoint from "../../../assets/images/stock.png";
import N_wws_Procurement from "../../../assets/images/feild_icon.png";
import port_icon from "../../../assets/images/port_icon.png";
import N_wws_Export from "../../../assets/images/export_assist_icon.png";
import ServiceContact from "../../../_Pages/_webapp/OurServises/ServiceContact";
import Subscribe from "../../../_Pages/_webapp/_mainHome/Subscribe";
import WebFooter from "../../../_components/_webapp/Footer/WebFooter";

const WweProcessor = (props) => {
  const [lang, setLang] = useState("en");
  useEffect(() => {
    let lang = localStorage.getItem("lang");
    setLang(lang);
    const metaTags = document.getElementsByTagName("meta");
    for (const tag of metaTags)
      if (tag.name === "description")
        tag.content =
          "Arya is one of the best post-harvest solutions platforms that serve processors and traders to manage their procurement and storage efficiently. Visit now!";
  }, []);

  return (
    <>
      <Helmet>
        <title>Who we Serve | Processors / Traders | Arya</title>
        {/* <meta name="keywords" content="Get loan on agri products, Get loan on agri commodities, Get loan on wheat,  Get loan on paddy,  Get loan on cotton,  Get loan on sugar, Get loan on maize, Get loan on pulses" /> */}
      </Helmet>
      <SetHeader active={"story"} history={props.history}></SetHeader>
      <section className="Whoweservebanner processorBanner">
        <Container>
          <Row>
            <Col>
              <div className="wws_banner_portion">
                <div className="wws_banner_heading">
                  <h1>
                    {localStorage.getItem("warehouseCount")
                      ? localStorage.getItem("warehouseCount") + "+"
                      : "9600+"}
                    <MultiLanguageTranslation title=" Warehouses Across " />
                    {localStorage.getItem("districtCount")
                      ? localStorage.getItem("districtCount") + "+"
                      : "800+"}
                    <MultiLanguageTranslation title=" Locations" />
                  </h1>
                </div>
                <div className="wws_banner_heading_content">
                  <a href="/WhoWeServeFPO">
                    <img alt="" src={N_tick} />
                    <span>
                      <MultiLanguageTranslation title="Farmer & FPO" />
                    </span>
                  </a>
                  <a href="/WhoWeServe/Processor">
                    <img alt="" src={N_tick} />
                    <span>
                      <MultiLanguageTranslation title="Processors" />
                    </span>
                  </a>
                  <a href="/WhoWeServe/Agri_corporation">
                    <img alt="" src={N_tick} />
                    <span>
                      <MultiLanguageTranslation title="Agri Corporations" />
                    </span>
                  </a>
                  <a href="/WhoWeServe/Financial">
                    <img alt="" src={N_tick} />
                    <span>
                      <MultiLanguageTranslation title="Financial Institutions" />
                    </span>
                  </a>
                  <a href="/WhoWeServe/InternationalBuyer">
                    <img alt="" src={N_tick} />
                    <span>
                      <MultiLanguageTranslation title="International Buyers" />
                    </span>
                  </a>
                  <a href="/WhoWeServe/DevelopmentActors">
                    <img alt="" src={N_tick} />
                    <span>
                      <MultiLanguageTranslation title="Development Actors" />
                    </span>
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="NA_customBreadcumb">
              <Link onClick={() => props.history.push("/")}>
                <MultiLanguageTranslation title="Arya.ag" />
              </Link>{" "}
              <span>→</span>{" "}
              <Link onClick={() => props.history.push("/WhoWeServe")}>
                <MultiLanguageTranslation title="Who We Serve" />
              </Link>{" "}
              <span>→</span>
              <span className="breadcrumb_active">
                <MultiLanguageTranslation title="Processors / Traders" />
              </span>
            </div>
          </div>
        </div>
      </div>

      <section className="N_wws">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="N_wws_heading">
                <h2>
                  <MultiLanguageTranslation title="Processors / Traders" />
                </h2>
              </div>
              <div className="wws_desc">
                <p>
                  <MultiLanguageTranslation title="who_we_serve_page_title_Agri_processing_enterprises" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="N_wws_offer_por">
        <Container>
          <Row>
            <Col>
              <div className="N_wws_offer">
                <div className="N_wws_offer_heading">
                  <h4>
                    <MultiLanguageTranslation title="Our Offerings" />
                  </h4>
                </div>
                <div className="N_wws_offer_content-sec">
                  <div className="N_wws_offer_content">
                    <img alt="" src={N_wws_warehousing} />
                    <h5>
                      <MultiLanguageTranslation title="Warehousing" />
                    </h5>
                  </div>

                  <div className="N_wws_offer_content">
                    <img alt="" src={N_wws_fumigation} />
                    <h5>
                      <MultiLanguageTranslation title="Fumigation" />
                    </h5>
                  </div>

                  <div className="N_wws_offer_content">
                    <img alt="" src={test_icon} />
                    <h5>
                      <MultiLanguageTranslation title="Quality Testing & Assaying" />
                    </h5>
                  </div>

                  <div className="N_wws_offer_content">
                    <img alt="" src={port_icon} />
                    <h5>
                      <MultiLanguageTranslation title="Port & Rake Handling & Stockpoint Audits" />
                    </h5>
                  </div>

                  <div className="N_wws_offer_content">
                    <img alt="" src={N_wws_Stockpoint} />
                    <h5>
                      <MultiLanguageTranslation title="Warehouse & Stockpoint Audits" />
                    </h5>
                  </div>

                  <div className="N_wws_offer_content">
                    <img alt="" src={N_wws_Procurement} />
                    <h5>
                      <MultiLanguageTranslation title="On Field Farmer Procurement" />{" "}
                    </h5>
                  </div>

                  <div className="N_wws_offer_content">
                    <img alt="" src={N_wws_Procurement} />
                    <h5>
                      <MultiLanguageTranslation title="Quality Procurement Assistance & Monitoring" />{" "}
                    </h5>
                  </div>

                  <div className="N_wws_offer_content">
                    <img alt="" src={N_wws_Export} />
                    <h5>
                      <MultiLanguageTranslation title="Export Assistance" />
                    </h5>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <ServiceContact />

      <section className="formContent">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1>
                <MultiLanguageTranslation title="Arya - The Best Partner for Agri Traders" />
              </h1>

              <p>
                <MultiLanguageTranslation title="processor_p1" />
              </p>
              <p>
                <MultiLanguageTranslation title="processor_p2" />
              </p>

              <h2>
                <MultiLanguageTranslation title="Arya's Services for Agricultural traders are as follows" />
              </h2>
              <ul>
                <li>
                  <MultiLanguageTranslation title="Warehousing" />
                </li>
                <li>
                  <MultiLanguageTranslation title="Fumigation" />
                </li>
                <li>
                  <MultiLanguageTranslation title="Assaying and testing for quality" />
                </li>
                <li>
                  <MultiLanguageTranslation title="Port and Rake Handling Audits, as well as Stock point Audits" />
                </li>
                <li>
                  <MultiLanguageTranslation title="Audits of warehouses and stockpiles" />
                </li>
                <li>
                  <MultiLanguageTranslation title="On the subject of Field Farmer Procurement" />
                </li>
                <li>
                  <MultiLanguageTranslation title="Procurement Assistance & Monitoring of High-Quality" />
                </li>
                <li>
                  <MultiLanguageTranslation title="Assistance with Exports" />
                </li>
              </ul>

              <h3>
                <MultiLanguageTranslation title="Why should you choose Arya as your partner for Agri traders?" />{" "}
              </h3>
              <p>
                {lang === "hindi" ? (
                  <MultiLanguageTranslation title="processor_p3" />
                ) : (
                  <>
                    Arya's clientele is farmers,{" "}
                    <a href="https://www.arya.ag/WhoWeServeFPO">
                      farmer producer organizations{" "}
                    </a>{" "}
                    (FPOs), financial institutions, small and medium-sized
                    agricultural processors, commodities dealers, and large
                    agribusinesses. Arya also provides warehouse receipt finance
                    via Aryadhan, an NBFC subsidiary that is wholly owned by
                    Arya. Therefore, farmers, FPOs, and SME aggregators
                    (processors/traders) that have stored agricultural goods in
                    the Arya warehouse network are eligible to apply for loans
                    via Aryadhan.
                  </>
                )}
              </p>

              <p>
                <MultiLanguageTranslation title="processor_p4" />
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="N_stay_update">
        <div className="container">
          <div className="row">
            <Subscribe></Subscribe>
          </div>
        </div>
      </section>
      <WebFooter />
    </>
  );
};
export default WweProcessor;
